export default __webpack_public_path__ + "static/media/one-step.912f685d.svg";